export var SiteDeleteErrorCode;
(function (SiteDeleteErrorCode) {
    SiteDeleteErrorCode["INVALID_ARGUMENT_SITE"] = "mom.invalidArgument.site";
})(SiteDeleteErrorCode || (SiteDeleteErrorCode = {}));
